import api from 'axios'
import { URL_BACK } from '../../viariableProd'
const path = URL_BACK + '/data.php'
const areas = URL_BACK + '/getArea.php'
const images = URL_BACK + '/getImages.php'
const trabajosLibres = URL_BACK + '/getTrabajosLibres.php'
const constancia = URL_BACK + '/downloadConstancia.php'
const marquesina = URL_BACK + '/getMarqueeMessages.php'
const constanciaData = URL_BACK + '/getConstanciasData.php'
const getStateSystem = URL_BACK + '/getStateSystem.php'
const getMensajes = URL_BACK + '/getMensajes.php'
// config Basic authentication request
// Contiene Subnet
export default {
  apiConfig (subnet) {
    return new Promise((resolve, reject) => {
      api
        .get(path + '?subnet=' + subnet)
        .then(response => {
          // console.log(JSON.stringify(response))
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // Contiene Subnet
  getAreas (subnet) {
    return new Promise((resolve, reject) => {
      api
        .get(areas + '?subnet=' + subnet)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // Contiene Subnet
  getImages (subnet, type) {
    return new Promise((resolve, reject) => {
      const url = images + '?subnet=' + subnet + '&type=' + type
      api
        .get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // Contiene Subnet
  getTrabajosLibres (subnet) {
    return new Promise((resolve, reject) => {
      api
        .get(trabajosLibres + '?subnet=' + subnet)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getConstancia (subnet, credentials) {
    // console.log('Data to send ' + credentials)
    // let url = constancia + '?folio=' + credentials + '&download=1'
    let url = constancia + '?folio=10000&download=1&subnet=' + subnet
    // console.log('URL' + url)
    return new Promise((resolve, reject) => {
      api
        .post(url, credentials, {responseType: 'arraybuffer'})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getMarquesina (subnet) {
    return new Promise((resolve, reject) => {
      api
        .get(marquesina + '?subnet=' + subnet)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // Contiene Subnet
  getConstanciaData (subnet, email) {
    return new Promise((resolve, reject) => {
      const url = constanciaData + '?subnet=' + subnet + '&correo=' + email
      api
        .get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // Contiene Subnet
  getStateSystem (subnet) {
    return new Promise((resolve, reject) => {
      const url = getStateSystem + '?subnet=' + subnet
      api
        .get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // Contiene Subnet
  getMensajes (subnet, mod) {
    return new Promise((resolve, reject) => {
      const url = getMensajes + '?subnet=' + subnet + '&modulo=' + mod
      // console.log(url)
      api
        .get(url)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/config.js